import React from "react";
import "./NoData.css";

const NoData = () => {
  return <div className="noDataPage">There are no records to display</div>;
};

export default NoData;
